// La moneda del anuncio: una sola para el anuncio, sus alojamientos y sus tarifas.
export const monedaAnuncio = {
  chipTitle: "Moneda del anuncio",
  change: "Cambiar",
  mismatchDot: "Las monedas de este anuncio no coinciden",
  channexText: "Este anuncio está conectado a Channex. Allí la moneda de una tarifa no se puede cambiar: hay que recrearla. Escríbenos y lo hacemos sin cortar tus ventas en las OTAs.",
  channexOnly: "Está conectado a Channex: solo puede usar {currency}, la moneda de sus tarifas allí.",
  modal: {
    title: "Moneda del anuncio",
    lead: "Es la moneda en la que cobras a los huéspedes de este anuncio.",
    scope: "Se cambia a la vez en el anuncio, en todos sus alojamientos y en sus tarifas. Los enlaces de pago, el agente de IA y la salida tardía usarán esta moneda.",
    label: "Moneda",
    mismatch: "Ahora mismo no coinciden: el anuncio dice {listing} y sus alojamientos cobran en {units}. Al guardar quedará todo en la misma.",
    channexTitle: "No se puede cambiar desde aquí",
    cancel: "Cancelar",
    close: "Entendido",
    save: "Guardar",
    saving: "Guardando…",
    saved: "Moneda del anuncio actualizada a {currency}.",
    error: "No se pudo cambiar la moneda. Inténtalo de nuevo.",
  },
  sugerencia: {
    titleCountry: "Este anuncio cobra en {current}",
    textCountry: "En {country} se suele cobrar en {suggested}. Si la cambias, los enlaces de pago, el agente de IA y la salida tardía usarán {suggested}.",
    titleMismatch: "Las monedas de este anuncio no coinciden",
    textMismatch: "El anuncio dice {listing} y sus alojamientos cobran en {units}. Deja una sola para que lo que anuncia la IA y lo que se cobra sea lo mismo.",
    useSuggested: "Cambiar a {currency}",
    other: "Elegir otra",
    keep: "Mantener {currency}",
  },
};
